import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const PopulationShareChart = ({ data, title, locationNames = [] }) => {
    const chartOptions = {
        chart: {
            type: 'column',
            style: {
                fontFamily: 'SCDream4',
            },
        },
        title: {
            text: title,
            style: {
                fontSize: '16px',
                fontWeight: '600',
                color: '#2c3e50',
                textAlign: 'center',
            },
            margin: 30,
        },
        xAxis: {
            categories: locationNames,
            // title: {
            //     text: '지역명',
            //     style: {
            //         color: '#34495e',
            //         fontWeight: '600',
            //         fontSize: '14px',
            //     },
            // },
            // labels: {
            //     style: {
            //         color: '#5a6c7d',
            //         fontSize: '13px',
            //         fontWeight: '500',
            //     },
            // },
            title: {
                text: null,
            },
            lineColor: '#e9ecef',
            tickColor: '#e9ecef',
        },
        yAxis: {
            // title: {
            //     text: '점유율',
            //     style: {
            //         color: '#34495e',
            //         fontWeight: '600',
            //         fontSize: '14px',
            //     },
            // },
            // labels: {
            //     format: '{value}%',
            //     style: {
            //         fontSize: '12px',
            //         color: '#5a6c7d',
            //         fontWeight: '500',
            //     },
            // },
            title: {
                text: null,
            },
            max: 100,
            gridLineColor: '#e9ecef',
            gridLineWidth: 1,
            lineColor: '#e9ecef',
            tickColor: '#e9ecef',
        },
        legend: {
            enabled: true,
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            itemStyle: {
                color: '#34495e',
                fontSize: '12px',
                fontWeight: '500',
            },
            itemHoverStyle: {
                color: '#2c3e50',
            },
            itemDistance: 20,
        },
        plotOptions: {
            series: {
                stacking: 'normal',
                borderRadius: 4,
                dataLabels: {
                    enabled: true,
                    format: '{point.y:.1f}%',
                    style: {
                        fontSize: '11px',
                        fontWeight: '700',
                        textOutline: '2px contrast',
                        color: '#ffffff',
                    },
                },
                states: {
                    hover: {
                        brightness: 0.2,
                    },
                },
            },
            column: {
                borderWidth: 0,
                groupPadding: 0.15,
                pointPadding: 0.1,
            },
        },
        tooltip: {
            shared: true,
            backgroundColor: 'rgba(44, 62, 80, 0.7)',
            borderColor: '#34495e',
            borderRadius: 8,
            borderWidth: 1,
            shadow: {
                color: 'rgba(0,0,0,0.2)',
                offsetX: 2,
                offsetY: 2,
                width: 4,
            },
            style: {
                color: '#ffffff',
                fontSize: '13px',
            },
            formatter: function () {
                const categoryName = this.points[0].category;
                let tooltip = '<b style="color: #ffffff; font-size: 14px;">' + categoryName + '</b><br/>';

                this.points.forEach((point) => {
                    tooltip +=
                        '<span style="color: #e8e8e8; font-size: 12px;">' +
                        point.series.name +
                        '</span>' +
                        ': <b style="color: #ffffff; font-size: 13px;">' +
                        point.y.toFixed(1) +
                        '%</b><br/>';
                });

                return tooltip;
            },
        },
        series: [
            {
                name: '60세 이상',
                data: data?.age60plus,
                color: '#ff6b9d',
            },
            {
                name: '50~59세',
                data: data?.age50to59,
                color: '#c44569',
            },
            {
                name: '40~49세',
                data: data?.age40to49,
                color: '#f0932b',
            },
            {
                name: '30~39세',
                data: data?.age30to39,
                color: '#ffbe76',
            },
            {
                name: '20~29세',
                data: data?.age20to29,
                color: '#feca57',
            },
            {
                name: '10~19세',
                data: data?.age10to19,
                color: '#48dbfb',
            },
            {
                name: '0~9세',
                data: data?.age0to9,
                color: '#0abde3',
            },
        ],
        credits: {
            enabled: false,
        },
    };

    return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
};

export default PopulationShareChart;
